import { CircularProgress, Grid, makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import { Formik } from 'formik';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import GenericForm from 'skyone-lib/lib/GenericForm';
import ApplicationState from 'store/interfaces';
import { applyI18n } from 'utils/helpers';
import formStyles from '../styles';
import screenFields from './formFields';
import { initialValues } from './initialValues';
import validationSchema from './schema';

const useStyles = makeStyles(formStyles);

interface Props {
  defaultValues?: typeof initialValues;
  isLoadingUsers: boolean;
  onSubmit: (values: typeof initialValues) => void;
  onCancel: () => void;
}

const FormUser = ({
  defaultValues,
  isLoadingUsers,
  onSubmit,
  onCancel,
}: Props) => {
  const classes = useStyles();

  return (
    <Grid item container className={classes.formUser}>
      <Formik
        initialValues={defaultValues || initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ setFieldValue, submitForm, errors, values }) => (
          <Grid container spacing={2}>
            <GenericForm
              fields={values}
              screenFields={applyI18n(screenFields, i18n.language)}
              setFieldValue={setFieldValue}
              errors={errors}
            />

            <Grid container justify="flex-end" className={classes.buttonsBase}>
              <Grid container className={classes.buttonsAlign}>
                <Button id="submit-button" onClick={submitForm} submitButton>
                  {isLoadingUsers ? (
                    <CircularProgress size={12} />
                  ) : (
                    i18n.t('SAVE_KEY')
                  )}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={onCancel}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
};

const mapStateToProps = ({
  clients: { isLoadingUsers },
}: ApplicationState) => ({
  isLoadingUsers,
});

export default connect(mapStateToProps, {})(FormUser);
